import cn from 'classnames';

const scoreBandClass = (score: number): string => {
  if (score >= 90) return 'band-success';
  if (score >= 80) return 'band-brand';
  if (score >= 70) return 'band-warning';
  return 'band-danger';
};

interface ScorecardGaugeProps {
  score: number;
  size?: number;
  strokeWidth?: number;
}

export const ScorecardGauge = ({ score, size = 140, strokeWidth = 12 }: ScorecardGaugeProps) => {
  const cleanScore = Math.min(100, Math.max(0, score));
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDashoffset = circumference - (cleanScore / 100) * circumference;
  const band = scoreBandClass(cleanScore);

  return (
    <div className='scorecard-gauge'>
      <div className='scorecard-gauge-ring' style={{ width: size, height: size }}>
        <svg className='scorecard-gauge-svg' width={size} height={size}>
          <circle
            className='scorecard-gauge-track'
            strokeWidth={strokeWidth}
            fill='transparent'
            r={radius}
            cx={size / 2}
            cy={size / 2}
          />
          <circle
            className={cn('scorecard-gauge-fill', band)}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap='round'
            fill='transparent'
            r={radius}
            cx={size / 2}
            cy={size / 2}
          />
        </svg>
        <div className='scorecard-gauge-label'>
          <span className='scorecard-gauge-value'>{cleanScore.toFixed(0)}%</span>
          <span className='scorecard-gauge-caption'>Avg Score</span>
        </div>
      </div>
    </div>
  );
};
